import { render, staticRenderFns } from "./addCottage.vue?vue&type=template&id=a169ea6c"
import script from "./addCottage.vue?vue&type=script&lang=js"
export * from "./addCottage.vue?vue&type=script&lang=js"
import style0 from "./addCottage.vue?vue&type=style&index=0&id=a169ea6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports